/* istanbul ignore next */
/**
 * @deprecated please use the ProviderName enum that is in @ucc/calendar-service package
 */
var ProviderName;
(function (ProviderName) {
    ProviderName["GOOGLE"] = "google";
    ProviderName["OFFICE365"] = "office365";
    ProviderName["EXCHANGE"] = "exchange";
    ProviderName["CHOOSE"] = "CHOOSE";
})(ProviderName || (ProviderName = {}));

export { ProviderName };
